import { PropsWithChildren, useEffect, useState } from 'react';

import { BottomSheet } from '@ravago/shared/radiance/components/bottom-sheet/components/BottomSheet/BottomSheet';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { IconButton } from '@ravago/shared/radiance/components/button/components/IconButton/IconButton';
import { ClientPortal } from '@ravago/shared/radiance/components/client-portal/components/ClientPortal/ClientPortal';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { useBottomContainerContext } from '../../../../context/bottom-container-context';

interface Props extends PropsWithChildren {
   title: string;
}

export const RequestForQuotationMobile = ({ title, children }: Props) => {
   const translate = useTranslations();
   const [open, setOpen] = useState(false);
   const { setHasBottomSheet } = useBottomContainerContext();

   useEffect(() => {
      setHasBottomSheet(true);

      return () => {
         setHasBottomSheet(false);
      };
   }, [setHasBottomSheet]);

   return (
      <ClientPortal selector="body">
         <BottomSheet
            expanded={open}
            container={false}
            header={
               <Box justify="between" content="center">
                  <Typography component="span" variant="headline" color="primary">
                     {translate(title)}
                  </Typography>
                  <IconButton icon={open ? 'chevron-down' : 'chevron-up'} ariaLabel="open" />
               </Box>
            }
            viewport
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
         >
            {children}
         </BottomSheet>
      </ClientPortal>
   );
};
